import { render } from "./JPageSvgInformation.vue?vue&type=template&id=287920cb&scoped=true"
import script from "./JPageSvgInformation.vue?vue&type=script&lang=js"
export * from "./JPageSvgInformation.vue?vue&type=script&lang=js"

import "./JPageSvgInformation.vue?vue&type=style&index=0&id=287920cb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-287920cb"]])

export default __exports__